module.exports = __webpack_public_path__ + "static/media/sign.5e831aab.svg";